import { z } from "zod";

export const HtmlSnapshotResponseBodySchema = z.object({
  status: z.union([z.literal("OK"), z.literal("FAIL"), z.literal("THROTTLED")]),
});

export type HtmlSnapshotResponseBodyType = z.infer<
  typeof HtmlSnapshotResponseBodySchema //
>;
